import React from "react";
import AgreementPreview from "@/components/agreements/agreement-preview";
import { GetServerSidePropsContext } from "next";

export default function AgreementPage({
  agreementId,
}: {
  agreementId: string;
}) {
  return <AgreementPreview agreementId={agreementId} />;
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const agreementId = context.params?.agreementId as string;
  return {
    props: {
      agreementId,
    },
  };
}
